/**
 * 抖音授权
 * https://open.douyin.com/platform/doc/6850443437020432397
 */
import * as Jdouyin from '@/utils/Jdouyin';
import Utils from '@/utils/utils';

import authUtils from '../authUtils';

const { DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID } = authUtils.config;
const wechatApi = authUtils.wechatApi;
const readerCenterApi = authUtils.readerCenterApi;
const channelCenterApi = authUtils.channelCenterApi;

class DouyinAuthorize {
  constructor({
    query,
    snsapiBase,
    officialAccountsId,
    defaultAuthorize
  }) {
    this.query = query || {};
    this.snapsis = snsapiBase || false;
    this.officialAccountsId = officialAccountsId || DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID;
    this.defaultAuthorize = defaultAuthorize || false; // 是否需要进入时授权
    // Jdouyin init
    Jdouyin.init();
  }

  checkLogged() {
    const { wechatUserId, userType } = authUtils.getCookieUser();
    // 是否真实用户
    return userType === authUtils.CONSTANT.USER_TYPE_REGULAR && !!wechatUserId;
  }

  /**
   * 检查是否存在openid
   * @returns {boolean}
   */
  checkOpenid() {
    return !!this.query.openid;
  }

  /**
   * 通过openid获取用户信息
   */
  getByOpenid() {
    const data = {
      openId: this.query.openid,
      officialAccountsId: DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID
    };
    return readerCenterApi.getUserInfoByOpenId(data);
  }

  /**
   * 进入默认授权
   */
  enterAuthorize() {
    return this.defaultAuthorize;
  }

  /**
   * 是否有code信息
   * @returns {boolean}
   */
  checkCode() {
    return !!this.query.code;
  }

  /**
   * 通过code获取用户信息
   * @returns Promise
   */
  getByCode() {
    const { code, phone } = this.query;
    const data = {
      scope: 'user_info',
      code,
      phone,
      officialAccountsId: DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID,
      localCode: authUtils.getLocalCode()
    };
    return wechatApi.douyinUser(data);
  }

  /**
   * 发起授权
   */
  forward = async () => {
    const baseUrl = `${window.location.origin}/wechat/douyinAuth/forward?`;
    let redirectAuthorUrl = DouyinAuthorize.getAuthorizeUrl();
    // timestamp 后端授权没有参数回调异常
    redirectAuthorUrl = authUtils.padQuery(redirectAuthorUrl, {
      timestamp: new Date().getTime()
    });
    const redirect = (domain) => {
      let header = domain ? `${location.protocol}//${domain}` : location.origin;
      let params = {
        officialAccountsId: DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID,
        redirectUrl: `${header}/wechat/douyinAuth/redirectUrl?path=${encodeURIComponent(redirectAuthorUrl)}`,
        // scope: 'user_info,mobile'
        scope: 'user_info'
      };
      if(Utils.browser().douyin) {
        Jdouyin.showOpenAuth({
          success: (res) => {
            window.location.replace(`${authUtils.padQuery(redirectAuthorUrl, {
              code: res.ticket
            })}`);
          },
          error: (res) => alert(JSON.stringify(res))
        });
      } else {
        window.location.replace(`${baseUrl}${authUtils.json2params(params)}`);
      }
    };
    try {
      const json = await channelCenterApi.getDomainByWechat({ accountSettingId: this.officialAccountsId });
      const domain = json.domain ? json.domain : json.data.domain;
      redirect(domain);
    } catch(e) {
      redirect();
    }
  }

  static getAuthorizeUrl() {
    const href = window.location.href, search = window.location.search;
    if(search.indexOf('code') > -1) {
      const query = authUtils.getUrlQuery();
      delete query.code;
      delete query.scope;
      delete query.app_id;
      return (
        window.location.origin + window.location.pathname + '?' + authUtils.json2params(query)
      );
    } else {
      return href;
    }
  }
}

export default DouyinAuthorize;